export default __webpack_public_path__ + "static/media/check-mark.7da1abb4.png";